<template>
  <div class="wf-variables-page">
    <WfVariablesTableLoading v-if="isLoading" />
    <template v-else>
      <WfVariablesEmptyLibraries v-if="isEmptyLibraries" />
      <template v-else>
        <WfVariablesTable v-if="variablesSyncState === 'ready'" />
        <WfVariablesSuccessMessage v-else-if="variablesSyncState === 'success'" />
      </template>
    </template>
  </div>
</template>

<style lang="scss" scoped>
:global(.tippy-box[data-theme~='default-mode-tooltip']) {
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  line-height: 1.5;
  color: white;
  border-radius: 2px;
  background-color: #222;
  transform: translateX(-30px) translateY(-20px);
}
</style>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { dispatch, handleEvent, removeEvent } from '@/figma/ui-message-handler';
import WfVariablesTable from './WfVariablesTable.vue';
import WfVariablesTableLoading from './WfVariablesTableLoading.vue';
import WfVariablesEmptyLibraries from './WfVariablesEmptyLibraries.vue';
import WfVariablesSuccessMessage from './WfVariablesSuccessMessage.vue';

const LOCAL_COLLECTIONS_POLLING = 5000;
const LIBRARIES_COLLECTIONS_POLLING = 15 * 60 * 1000;

const store = useStore();
const variablesStore = useStore().state.variable;
const intervalId = ref(null);

// State from Vuex
const variablesSyncState = computed(() => store.state.variablesSyncState);
const isLoading = computed(() => variablesStore.isLoading);
const libraries = computed(() => variablesStore.libraries);

// Computed properties
const isEmptyLibraries = computed(() => !libraries.value.length);

onMounted(() => {
  handleEvent('setProjectLibraries', (libraries) =>
    store.dispatch('variable/updateLibraries', { libraries })
  );
  handleEvent('webflowVariableModeUnitUpdated', () =>
    dispatch('getProjectLibraries', { localOnly: true })
  );

  store.dispatch('variable/loadData').then(() => {
    dispatch('getProjectLibraries');

    const lastRemoteLibrariesUpdate = new Date();
    intervalId.value = setInterval(() => {
      const shouldUpdateRemoteLibraries =
        new Date().getTime() - lastRemoteLibrariesUpdate.getTime() > LIBRARIES_COLLECTIONS_POLLING;

      if (shouldUpdateRemoteLibraries) {
        lastRemoteLibrariesUpdate.setTime(new Date().getTime());
      }

      dispatch('getProjectLibraries', { localOnly: !shouldUpdateRemoteLibraries });
    }, LOCAL_COLLECTIONS_POLLING);
  });
});

onBeforeUnmount(() => {
  clearInterval(intervalId.value);
  removeEvent('setProjectLibraries');
  removeEvent('setLocalCollections');
  removeEvent('webflowVariableModeUnitUpdated');
});
</script>
